import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';


const theme = createMuiTheme({
    palette: {
        primary: {
            light: '#c5ffc2',
            main: '#5DAD58',
            dark: '#1d8a17',
            contrastText: '#fff',
        },
        secondary: {
            light: '#ff7961',
            main: '#ffffff',
            dark: '#ba000d',
            contrastText: '#000',
        },
    },
});


export default class App extends React.Component {

    componentDidMount () {
      
    }

    render() {
        return (
            <MuiThemeProvider theme={theme}>
                <CssBaseline />
                <div className="app">

                    {this.props.children}



                </div>
            </MuiThemeProvider>);
    }


};